import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { channelList, delChannel, disableChannel } from "@/api/channel";
import addchannel from "./components/addchannel";
export default {
  name: "channel",
  components: {
    addchannel: addchannel
  },
  data: function data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      sels: [],
      selsString: '',
      searchData: {
        page: 1,
        page_size: 10,
        channel_mark: '',
        channel_name: ''
      }
    };
  },
  created: function created() {
    this.getData(1);
  },
  methods: {
    handleSource: function handleSource(id, num) {
      this.$refs.addchannel.init(id, num);
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.getData(1);
    },
    getData: function getData(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.page = e;
                channelList(_this.searchData).then(function (res) {
                  if (res.status == 200) {
                    if (!res.data.data.length && e > 1) {
                      _this.getData(e - 1);
                    } else {
                      _this.tableData = res.data.data || [];
                      _this.total = res.data.total || 0;
                    }
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this2.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    handleDisable: function handleDisable(id, status) {
      var _this3 = this;

      disableChannel({
        id: id
      }).then(function (res) {
        if (res.status == 200) {
          Message({
            message: res.message,
            type: "success"
          });

          _this3.getData(_this3.searchData.page);
        }
      });
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delChannel({
                  id: id
                }).then(function (res) {
                  _this4.getData(_this4.searchData.page);
                });

                _this4.$message({
                  type: "success",
                  message: _this4.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};